/**
 * Friends' week (ADR 0043 part 5): me and my friends by beans earned this week, most first, me
 * among them. Friends appearing offline aren't in it; no table without a friend in it.
 */
export function weekTable(f: {
  friends: readonly { name: string; week?: number | null }[];
  mine?: { week: number };
}): { name: string; week: number; me: boolean }[] {
  const rows = f.friends
    .filter((p) => typeof p.week === "number")
    .map((p) => ({ name: p.name, week: p.week ?? 0, me: false }));
  if (rows.length === 0) return [];
  rows.push({ name: "You", week: f.mine?.week ?? 0, me: true });
  return rows.sort(
    (a, z) => z.week - a.week || Number(z.me) - Number(a.me) || a.name.localeCompare(z.name),
  );
}
